import Header from "../../components/Header/Header";
import iconTelWhite from "../../assets/icon_tel_wh.svg";
import imgMembership from "../../assets/landers_membership.jpg";
import { Accordion, AccordionItem } from "@szhsin/react-accordion";
import useReactGASend from "../../hooks/useReactGASend";
import { GiCheckMark } from "react-icons/gi";
import React from "react";


const common = [
  {
    title: "가입방법",
    content:
      "멤버십은 SSG랜더스 APP을 통해 가입/이용 가능합니다. \n\n 아래 링크를 통해 접속 후 이용 부탁드립니다. \n\n ※  멤버십 혜택은 당해 정규 시즌 기간 동안 이용 가능합니다.",
    reference: "",
    buttons: [
      { 
        title: "랜더스 APP 바로가기",
        link: "https://www.ssglanders.com/deepLink/membership"
      }
    ]
  },
  {
    title: "가입혜택",
    content:
      "멤버십 가입 후 다양한 혜택을 이용해 보세요 \n\n [ICON:check]멤버십 혜택 \n - 멤버십 선예매 \n - 멤버십 선입장/전용 게이트 이용\n[SPACE](푸리 이상 회원) \n- 등급별 가입선물 \n\n ※  제공 혜택은 멤버십 등급별로 상이합니다. \n\n 보다 자세한 내용은 랜더스 APP 및 공식 인스타그램 카드 뉴스를 참고하여 주기시 바랍니다.",
    reference: "",
    buttons: [
      { 
        title: "랜더스 APP 바로가기",
        link: "https://www.ssglanders.com/deepLink/membership"
      },
      { 
        title: "공식 인스타그램 바로가기",
        link: "https://www.instagram.com/ssglanders.incheon/"
      }
    ]
  },
  {
    title: "멤버십 선예매",
    content:
      "랜더스 APP을 통해 멤버십 가입 후 SSG랜더스 홈경기 선예매 이용이 가능합니다. \n\n [ICON:check]선예매 기준 \n- 랜디, 배티 회원 \n[SPACE] : 경기 7일 전 오전 11시~ \n- 푸리 회원 \n[SPACE]: 경기 6일 전 오전 11시~ \n- 프렌즈 회원 \n[SPACE]: 경기 5일 전 오전 11시~\n- 일반 고객 \n[SPACE]: 경기 4일 전 오전 11시~ \n\n ※ 멤버십 선예매는 랜더스 APP 예매를 통해서만 가능합니다.",
    reference: "",
  },
  {
    title: "멤버십 취소",
    content:
      "멤버십은 가입 후 멤버십 혜택을 이용하지 않으신 경우에 한 해 결제일로부터 14일 이내 취소(환불) 가능합니다. \n\n [ICON:check]취소 방법 \n- APP → 메뉴 → 우측 상단 톱니바퀴 → 최하단 [멤버십 탈퇴하기] 클릭 후 진행 \n\n ※ 멤버십 혜택을 이용하신 경우, 또는 가입 후 14일 경과 시 탈퇴 불가합니다.\n※ 패밀리(주니어) 멤버십은 가입기간 내에만 취소 및 탈퇴 가능합니다. \n※ 탈퇴 후 환불은 카드사에 따라 영업일 기준 3~7일 정도 소요될 수 있습니다.",
    reference: "",
  },
  {
    title: "선입장/전용게이트",
    content:
      "멤버십 가입 후 등급별 전용 게이트 이용 및 선입장이 가능합니다. \n\n [ICON:check]선입장 시간 \n- 주중 : 경기 시작 2시간 30분 전부터 \n- 주말 : 경기 시작 3시간 전부터 \n\n ※ 일반 관람객 입장시간 대비 1시간 선입장 가능 \n\n [ICON:check]전용 게이트 \n- 랜디 게이트 \n[SPACE]: 랜디 회원 전용  \n- 스타벅스 게이트 \n[SPACE]: 푸리 이상 회원 전용 \n ※ 멤버십 회원이 예매한 티켓에 한 해 동반인 동반 입장이 가능합니다.",
    reference: ""
  },
];


const ICON_MAP = {
  check: <GiCheckMark className="inline-block mr-1"/>
}

const formatText = (text) => {
  return text.split("\n").map((line, index) => {
    const elements = [];

    let rest = line;

    // 1. 앞에 [SPACE]가 몇 개 있는지 계산
    const spaceMatches = rest.match(/^(\[SPACE])+/);
    if (spaceMatches) {
      const count = spaceMatches[0].match(/\[SPACE\]/g).length;
      for (let i = 0; i < count; i++) {
        elements.push(<span key={`space-${i}`} className="pl-2" />);
      }
      rest = rest.replace(/^(\[SPACE\])+/,"").trim();
    }

    // 2. 아이콘 처리
    const iconMatch = rest.match(/\[ICON:(.+?)\]/);
    if (iconMatch) {
      const iconKey = iconMatch[1];
      elements.push(
        <span key="icon" className="inline-flex items-baseline">
          {ICON_MAP[iconKey]}
        </span>
      );
      rest = rest.replace(iconMatch[0], "").trim();
    }

    // 3. 텍스트
    elements.push(<span key="text">{rest}</span>);

    return (
      <div key={index} className="flex items-center">
        {elements}
        {index < text.split("\n").length - 1 && <br />}
      </div>
    );
  });
};

export const AccordionItemComponent = ({
  item,
  index,
}) => (
  <AccordionItem
    key={index}
    itemKey={index}
    className="mb-2"
    header={({state}) => 
      <div className={`flex items-center w-full pb-2 text-lg font-semibold text-gray-950 border border-[#D1D5DB] p-2.5 bg-white text-left ${state.isEnter ? 'rounded-bl-none rounded-br-none rounded-tl-[30px] rounded-tr-[30px] border-none' : 'rounded-full'}`}>
        <span
          className={`inline-flex items-center justify-center p-3 h-10 bg-black shadow-md rounded-full text-white text-2xl font-semibold shrink-0 mr-2`}
        >
          Q
        </span>
        {item.title}
      </div>
    }
  >
  {({state}) => 
    <div className={`p-6 border rounded-3xl border-[#D1D5DB] bg-white ${state.isEnter && 'rounded-tl-none rounded-tr-none border-none mt-[-10px]'}`}>
      <p className="font-medium text-gray-950">{formatText(item.content)}</p>
      {item.buttons && (
        <div className="flex justify-center flex-col">
          {item.buttons.map(button => (
            <LinkItem
              title={button.title}
              url={button.link}
              styles={"mx-6"}
            />
          ))}
        </div>
      )}
    </div>
  } 
  </AccordionItem>
);


export const LinkButton = ({
  url,
  className,
  imgSrc,
  altText,
  buttonText,
  onClick,
}) => (
  <a
    onClick={onClick}
    href={url}
    className={className}
  >
    <span className="shrink-0">
      <img src={imgSrc} alt={altText} />
    </span>
    <span className="flex-1 text-center">{buttonText}</span>
  </a>
);

export const LinkItem = ({ title, url, isPhoneLink, onClick, styles }) => (
  <li className="pt-4 list-none">
    <a
      onClick={onClick}
      href={url}
      target={isPhoneLink ? undefined : "_blank"}
      rel={isPhoneLink ? undefined : "noopener noreferrer"}
      className={`flex items-center bg-[#FFFFFF] ${
        isPhoneLink ? "gap-4" : ""
      } justify-center h-12 rounded-[16px] ${
        isPhoneLink ? "border-2" : "border"
      } border-[#FFA2A2] text-[#CE152D] font-semibold ${styles}`}
    >
      {isPhoneLink && <img alt="상담원 연결 전화 아이콘" />}
      {title}
    </a>
  </li>
);


const MembershipPage = () => {
  const { makeEventTrackFn } = useReactGASend();
  const trackButtonClick = (title) => {
    makeEventTrackFn({
      category: "event",
      action: title,
    });
  };

  return (
    <section className="p-hasHeader">
      <Header title="멤버십" />
      <div className="bg-white p-7 rounded-3xl mb-6 font-medium text-base mt-2 text-gray-950 flex justify-center">
        <img src={imgMembership} alt="유료멤버십" />
      </div>

      <Accordion transition transitionTimeout={250}>
        {common.map((item, index) => (
          <AccordionItemComponent
            key={index}
            item={item}
            index={index}
          />
        ))}
      </Accordion>

      <div className="flex flex-col items-center mt-10 bg-white p-5 rounded-3xl justify-center w-full ">
        <div className="text-base font-medium text-[#4A5565] pb-2 flex text-center justify-center">추가적인 도움이 필요하신가요?</div>
        <LinkButton
          url="tel:032-455-2600"
          className="flex items-center justify-between w-36 h-9 bg-brand-secondary rounded-[30px] text-white px-6 py-6 text-sm font-medium mb-1.5"
          imgSrc={iconTelWhite}
          buttonText="전화상담"
          onClick={() => trackButtonClick("멤버십_전화상담")}
        />
      </div>
    </section>
  );
};

export default MembershipPage;
